var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.deviceConfiguration && !_vm.deviceConfiguration.licenseKey
      ? _c("h3", { staticClass: "text-center mb-6" }, [
          _vm._v(" " + _vm._s(_vm.$t("roomWizard.addLicenseDescription")) + " ")
        ])
      : _vm._e(),
    _vm.deviceConfiguration && _vm.deviceConfiguration.licenseKey
      ? _c("div", { staticClass: "text-center mb-6" }, [
          _c("h3", { staticClass: "mb-2" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("roomWizard.licenseAlreadyAssociatedDescription"))
            ),
            _c("br"),
            _vm._v(" " + _vm._s(_vm.deviceConfiguration.licenseKey) + " ")
          ]),
          _vm._v(" " + _vm._s(_vm.$t("roomWizard.canChangeLicense")) + " ")
        ])
      : _vm._e(),
    _vm.licenseMode == undefined
      ? _c(
          "div",
          { staticClass: "d-flex justify-md-space-around my-8" },
          [
            _c(
              "v-btn",
              {
                attrs: { color: "primary" },
                on: {
                  click: function($event) {
                    _vm.licenseMode = "existing"
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("roomWizard.existingLicense")) + " ")]
            ),
            _c(
              "v-btn",
              {
                attrs: { color: "primary" },
                on: {
                  click: function($event) {
                    _vm.licenseMode = "new"
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("roomWizard.newLicense")) + " ")]
            )
          ],
          1
        )
      : _vm._e(),
    _vm.licenseMode == "new"
      ? _c(
          "div",
          [
            _c("new-license", {
              on: {
                onDismiss: function($event) {
                  _vm.licenseMode = undefined
                },
                onFinish: _vm.associateLicense
              }
            }),
            _vm._v(" " + _vm._s(_vm.$t("common.or")) + " "),
            _c(
              "a",
              {
                on: {
                  click: function($event) {
                    _vm.licenseMode = "existing"
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("roomWizard.existingLicense")))]
            )
          ],
          1
        )
      : _vm._e(),
    _vm.licenseMode == "existing"
      ? _c(
          "div",
          [
            _c("chose-license", {
              on: {
                onDismiss: function($event) {
                  _vm.licenseMode = undefined
                }
              },
              model: {
                value: _vm.license,
                callback: function($$v) {
                  _vm.license = $$v
                },
                expression: "license"
              }
            }),
            _vm._v(" " + _vm._s(_vm.$t("common.or")) + " "),
            _c(
              "a",
              {
                on: {
                  click: function($event) {
                    _vm.licenseMode = "new"
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("roomWizard.newLicense")))]
            )
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "d-flex justify-space-between my-8" },
      [
        !_vm.first
          ? _c("va-button", {
              staticClass: "mr-4",
              attrs: {
                color: "secondary",
                type: "outline",
                cta: _vm.$t("roomWizard.prev")
              },
              on: { click: _vm.onBack }
            })
          : _c("v-spacer"),
        _c("va-button", {
          attrs: {
            disabled:
              !_vm.license &&
              _vm.deviceConfiguration &&
              !_vm.deviceConfiguration.licensePackageId,
            loading: _vm.loading,
            cta: _vm.$t("roomWizard.next")
          },
          on: { click: _vm.activateSeat }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }